export const MAPTICA_STEPS = {
    basic: 0,
    import: 1,
    mapping: 2,
    products: 3,
    summary: 4,
} as const

export type MapticaStep = keyof typeof MAPTICA_STEPS

// Mapowanie workflow status → stepper step
export const WORKFLOW_TO_STEP_MAP: Record<string, MapticaStep> = {
    draft: 'basic',
    in_progress: 'import',
    header_selected: 'mapping',
    mapped: 'products',
    completed: 'summary',
}

// Mapowanie stepper step → route path
export const STEP_TO_ROUTE_MAP: Record<MapticaStep, string> = {
    basic: '/maptica/basic',
    import: '/maptica/import',
    mapping: '/maptica/mapping',
    products: '/maptica/products',
    summary: '/maptica/summary',
}

export function getMapticaStepIndex(step: string | undefined): number {
    if (!step || !(step in MAPTICA_STEPS)) {
        return 0
    }
    return MAPTICA_STEPS[step as MapticaStep]
}

export function getStepFromWorkflowStatus(status: string): MapticaStep {
    return WORKFLOW_TO_STEP_MAP[status] ?? 'basic'
}

export function getRouteForStep(step: MapticaStep): string {
    return STEP_TO_ROUTE_MAP[step]
}
